import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser, refresh } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;

    if (!sessionId) {
      navigate("/login", { replace: true });
      return;
    }

    (async () => {
      try {
        const { data } = await api.post(
          "/auth/google/session",
          {},
          { headers: { "X-Session-ID": sessionId } }
        );
        setUser(data);
        await refresh();
        toast.success("Google ile giriş başarılı");
        // Clean the fragment then go home
        window.history.replaceState(null, "", "/");
        navigate("/forum", { replace: true });
      } catch (_e) {
        toast.error("Google girişi başarısız oldu");
        navigate("/login", { replace: true });
      }
    })();
  }, [navigate, setUser, refresh]);

  return (
    <div className="k-container py-24 text-center font-body text-ink-700" data-testid="auth-callback">
      Giriş tamamlanıyor…
    </div>
  );
}
